<a [ngbPopover]="params.value" container="body" (click)="onDashboardClick($event)"
    popoverClass="CXoneMgtPopover" placement="bottom-left top-left" triggers="mouseenter:mouseleave" 
    [disablePopover]="params.value === null || params.value === ''" class="textContent">
    <div class="nameText" *ngIf="value" [textContent]="value"></div>
</a>